//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {utils} from "@/assets/utils/utils.js"
import dbmap from '@/assets/dbs/hashmap.js'
export default {
    data () {
        return {
            hintText:'',
            lend:'', //01定期贷款 02 循环贷款
            fbCode:"",
            title:'',
            hintContent:'',
            showButton:null,
            buttonShowId:{
                index:false,
                anginAC: false,
                login:false,
                angin:false,
                back:false,
                regiest:false,
                reApply: false,
                closeInfo:false,
            }
        }
    },
    mounted(){
        let fbCode = this.$route.query.code;
        this.fbCode = fbCode
        let routerParams = utils.routerJump.returnUrl(fbCode);
        this.title = routerParams.title;
        this.hintText = routerParams.messages;
        this.hintContent = routerParams.message;
        this.showButton = routerParams.showbutton;
        this.setButton();

    },
    methods:{
        setButton(){
            for(var i in this.showButton){
                switch(this.showButton[i]){
                    case "1":
                        this.buttonShowId.index = true;
                        break;
                    case "2":
                        this.buttonShowId.anginAC = true;
                        break;
                    case "3":
                        this.buttonShowId.login = true;
                        break;
                    case "4":
                        this.buttonShowId.angin = true;
                        break;
                    case "5":
                        this.buttonShowId.back = true;
                        break;
                    case "6":
                        this.buttonShowId.regiest = true;
                        break;
                    case "7":
                        this.buttonShowId.reApply = true;
                        break;
                    case "8":
                        this.buttonShowId.closeInfo = true;
                        break;
                }
            }
        },
        gotoPage(val){
            let url = '';
            switch(val){
                case "1":
                    url = 'index';
                    break;
                case "2":
                    url = 'stepDescription';
                    break;
                case "3":
                    url = 'login';
                    break;
                case "4":
                    url ='-1';
                    break;
                case "5":
                    url = '-1';
                    break;
                case "6":
                    url = 'index';
                    break;
                case "7":
                    url = '/questionnaire';
                    break;
                case "8":
                    // 关闭浏览器窗口
                    if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") !=-1) {
                        window.location.href = "about:blank"
                    } else {
                        window.opener = null;
                        window.open("about:blank", "_self");
                        window.close();
                    }
                    break;
            }

            if(url == ''){
                return false;
            }
            if(url == '-1'){
                this.$router.go(-1);return false;
            }
            this.$router.push({
                path: url,
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/view/feedBack.vue